import { createDarkTheme, createLightTheme } from '@fluentui/react-components';
import type { BrandVariants, Theme } from '@fluentui/react-components';

/**
 * SOC Dashboard colors matching the wall-screen design
 */
export const SOC_COLORS = {
  black: '#010101',
  teal: '#00b9b5',
  green: '#8dc63f',
  yellow: '#ffcb05',
  red: '#e8394a',
  orange: '#f5812a',
  surface: '#080f0f',
  surfaceAlt: '#060c0c',
  border: 'rgba(0,185,181,0.10)',
  textPrimary: '#deeaea',
  textMid: '#5a8080',
  textDim: '#2a4040',
};

/**
 * SOC brand colors based on teal accent
 */
const socBrandRamp: BrandVariants = {
  10: '#010101',
  20: '#060c0c',
  30: '#080f0f',
  40: '#0a1414',
  50: '#0d1a1a',
  60: '#102020',
  70: '#153030',
  80: '#00b9b5',
  90: '#1ac5c1',
  100: '#33ccc8',
  110: '#4dd3d0',
  120: '#66dad7',
  130: '#80e1df',
  140: '#99e8e6',
  150: '#b3efed',
  160: '#ccf6f5',
};

/**
 * Wall-screen dark theme optimized for large displays and dark environments.
 * Matches the SOC dashboard design with teal accents on black background.
 */
export const wallScreenDarkTheme: Theme = {
  ...createDarkTheme(socBrandRamp),
  colorNeutralBackground1: SOC_COLORS.black,
  colorNeutralBackground2: SOC_COLORS.surface,
  colorNeutralBackground3: SOC_COLORS.surfaceAlt,
  colorNeutralForeground1: SOC_COLORS.textPrimary,
  colorNeutralForeground2: SOC_COLORS.textMid,
  colorNeutralForeground3: SOC_COLORS.textDim,
  colorNeutralStroke1: SOC_COLORS.border,
  colorBrandForeground1: SOC_COLORS.teal,
  colorBrandForeground2: SOC_COLORS.teal,
};

/**
 * Standard light theme for personal/desktop use.
 */
export const personalLightTheme: Theme = {
  ...createLightTheme(socBrandRamp),
};
